import axios from 'axios';
import {
  assertErrorHasMessage,
  assertErrorHasResponse,
} from '../../utils/assert';
import { VERIFY_COUPON, VERIFY_COUPON_V2 } from './constant';

export function verifyCouponBilling(coupon, data) {
  return axios
    .post(
      VERIFY_COUPON(coupon),
      { ...data },
      {
        withCredentials: false,
        headers: {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          'Content-Type': 'application/json',
        },
      }
    )
    .catch((error) => {
      let eobj;
      if (error.response) {
        const { data: resp } = error.response;
        if (resp.errors) {
          let errorMessage = '';
          resp.errors.forEach((err, idx) => {
            if (idx === 0) {
              errorMessage = err.user_message;
            } else {
              errorMessage = `${errorMessage},${err.user_message}`;
            }
          });
          eobj = new Error(errorMessage);
        } else if (resp.message) {
          eobj = new Error(resp.message);
        } else {
          eobj = new Error(error.message);
        }
      } else {
        eobj = new Error(error.message);
      }
      return Promise.reject(eobj);
    });
}

export async function verifyCouponBillingV2(coupon, data) {
  try {
    return await axios.post(VERIFY_COUPON_V2(coupon), data);
  } catch (error) {
    assertErrorHasResponse(error);
    if (error.response && error.response.data.errors) {
      const { data: resp } = error.response;
      if (resp.errors) {
        throw new Error(resp.errors[0]);
      }
    } else {
      assertErrorHasMessage(error);
      throw new Error(error.message);
    }
  }
}
